import { ApiClient, ApiModelPortfolioUsage } from '@/api'

import { CheckboxAccordionItem } from '../../../molecules'
import { compareValues } from '.'

export const mapClientData = (
  clients: ApiClient[],
  portfolioUsage: ApiModelPortfolioUsage,
  allowedBusinessUnitIds: string[],
  compareData?: CheckboxAccordionItem[] // Optional data to compare against
): CheckboxAccordionItem[] => {
  const result: CheckboxAccordionItem[] = clients.map(client => {
    const businessUnits = client.businessUnits || []

    // Check if ALL business units are in allowedBusinessUnitIds
    const allBusinessUnitsAllowed =
      businessUnits.length > 0 &&
      businessUnits.every(bu => allowedBusinessUnitIds.includes(bu.businessUnitId))

    // Check if client ID is directly in allowedBusinessUnitIds OR all children are allowed
    const isClientAllowed =
      allowedBusinessUnitIds.includes(client.clientId) || allBusinessUnitsAllowed

    // Check if ANY business unit is in allowedBusinessUnitIds (but not all)
    const someBusinessUnitsAllowed =
      !allBusinessUnitsAllowed &&
      businessUnits.some(bu => allowedBusinessUnitIds.includes(bu.businessUnitId))

    // Find matching item in compareData (if provided)
    const compareClient = compareData?.find(c => c.id === client.clientId)
    const clientValue = portfolioUsage?.totalValueByClient?.[client.clientId] || 0
    let currentCheckedStatus: boolean | 'indeterminate'
    if (isClientAllowed) {
      currentCheckedStatus = true
    } else if (someBusinessUnitsAllowed) {
      currentCheckedStatus = 'indeterminate'
    } else {
      currentCheckedStatus = false
    }
    return {
      id: client.clientId,
      name: client.clientName,
      value: clientValue,
      highlighted: compareClient
        ? compareValues(
            { name: client.clientName, value: clientValue, checked: currentCheckedStatus },
            compareClient,
            businessUnits,
            compareClient.children || []
          )
        : false,
      checked: currentCheckedStatus,
      children: businessUnits.map(bu => {
        const compareBU = compareClient?.children?.find(c => c.id === bu.businessUnitId)
        const buValue = portfolioUsage?.totalValueByBusinessUnit?.[bu.businessUnitId] || 0
        const buChecked = allowedBusinessUnitIds.includes(bu.businessUnitId)
        return {
          id: bu.businessUnitId,
          name: bu.businessUnitName,
          value: buValue,
          highlighted: compareBU
            ? compareValues(
                { name: bu.businessUnitName, value: buValue, checked: buChecked },
                compareBU,
                [],
                []
              )
            : false,
          checked: allowedBusinessUnitIds.includes(bu.businessUnitId)
        }
      })
    }
  })

  return result
}
